import sessionService from '../../services/session.service';
import { changeSessionState, selectSessionId } from '../slices/session.slice';
import { AppDispatch, GetState, RootState } from '../store';
import { ProcessingState, SessionBank, SessionState } from '../../types/session';
import { reportError } from '../slices/error.slice';
import { saveSessionBank } from '../slices/bank.slice';
import { observe } from './observe.thunk';
import { Bank, BankCountry } from '../../services/interfaces/bank.interface';
import { ChooseBankData } from '../../services/interfaces/session.interface';

export const selectBank = (bank: Bank, country: BankCountry) => {
	return async (dispatch: AppDispatch, getState: GetState): Promise<void> => {
		try {
			const sessionId = getSessionId(getState());
			const data = createSelectionQuery(bank, country);
			const nextState = await sessionService.chooseBank(sessionId, data);

			const sessionBank = createSessionBank(bank, country);
			dispatch(saveSessionBank(sessionBank));

			if (isProcessingState(nextState)) {
				return await dispatch(observe());
			}

			dispatch(changeSessionState(nextState));
		} catch (error: any) {
			dispatch(
				reportError({
					type: 'TECHNICAL',
					reason: error,
					message: 'We are having technical difficulties. Please try again later.'
				})
			);
		}
	};
};

const getSessionId = (state: RootState) => {
	const sessionId = selectSessionId(state);
	if (!sessionId) throw new Error('Session id not defined on choose bank action');
	return sessionId;
};

const createSelectionQuery = (bank: Bank, country: BankCountry): ChooseBankData => {
	const bankCode = getBankCode(bank);
	return {
		bankCode,
		countryCode: country
	};
};

const isProcessingState = (state: SessionState): state is ProcessingState => {
	return state.status === 'PROCESSING';
};

const createSessionBank = (bank: Bank, country: BankCountry): SessionBank => {
	const bankCode = getBankCode(bank);
	const bankName = bank.name;
	const countryCode = country;
	return {
		bankCode,
		bankName,
		countryCode
	};
};

const getBankCode = (bank: Bank) => {
	return bank.bankCodes[0];
};
